export const {
  getAllTickets,
  getAllTicketBaseQueryFilter,
  getReviewTickets,
  getAssignedTicketsHelper,
  getTagHistoryAndCombinedTagsForAConversation,
  nominatedExpertQueue,
  getConversationById,
  getEscalatedTickets,
  getEscalatedTicketsBaseQuery,
} = require('./ticketsGraphQL');
